import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EmptyList } from '../../components/EmptyList';
import { clearFilters } from '../../actions/filters';
import { loadReviews } from '../../actions/reviews/loadReviews';
import { loadQuestions } from '../../actions/questions';
import { getIsReviewTab } from '../../selectors/tabs';
import { TThunkDispatch } from '../../types/redux';

interface IEmptyListContainerProps {
  showExtra?: boolean;
}

export const EmptyListContainer = ({ showExtra = true }: IEmptyListContainerProps) => {
  const dispatch = useDispatch<TThunkDispatch>();
  const isReviewTab = useSelector(getIsReviewTab);

  const onClick = React.useCallback(() => {
    const loadFn = isReviewTab ? loadReviews : loadQuestions;

    dispatch(clearFilters());
    dispatch(loadFn());
  }, [dispatch, isReviewTab]);

  return <EmptyList onClick={onClick} showExtra={showExtra} />;
};
